module.exports = __webpack_public_path__ + "static/media/qq.eb13b08d.svg";